module.exports = __webpack_public_path__ + "static/media/arrow.a7ed1a54.svg";